export default __webpack_public_path__ + "static/media/filter.8b744a0f.svg";